import React, { useState, useEffect, useRef} from 'react';
import Select from 'react-select';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label
} from "reactstrap";
import customerApi from '../../services/customer.service';
import helper from '../../services/helper.service';
import session from '../../services/session.service';
import AddClubHeader from '../../components/Headers/AddClubHeader';
import './gameList.scss';
import CustomerHeader from '../../components/Headers/CustomerHeader';
import GoogleMapReact from 'google-map-react';
import CustomMarker from '../../components/Markers/CustomMarker';
import MapLegend from '../../components/MapLegend';
import { diffInMinutes, format12Hours, format24Hours, strTo12Hours, strTo24Hours } from '../../utils/date';
import adminService from '../../services/admin.service';
import useCourseSelection from '../../hooks/useCourseSelection';
import { calculateGameProperties, getLocalDate, boxToHoleMappings, holeToBoxMappings, statusText, sortGames, getTransportDisplay } from '../../utils/games';
import {
  formatBatteryLevel,
  getBatteryLevelStyle,
  isLowBattery,
} from '../../utils/gpsTrackerBattery';
import { useHistory } from 'react-router-dom';
import html2pdf from 'html2pdf.js';

let interval = null;
let interval2 = null;
const PHONE_MAX_WIDTH = 768;
const HISTORY_PER_PAGE = 50;

const isHistoryDate = (date) => String(date).includes('history');

const resolveFacilityId = (clubState) => {
  const raw = clubState?.facility_id ?? session.get('clubInfo')?.facility_id;
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
};

/** Multi-course facility dashboard/map: live dates only (history stays single-club). */
const isFacilityCombinedView = (facilityId, has27, selectedDate) =>
  Boolean(facilityId) && !has27 && !isHistoryDate(selectedDate);

/** Inline equivalents of former gameList.scss sticky scroll / table header rules */
const GAME_LIST_TABLE_STYLE = {
  borderCollapse: 'separate',
  borderSpacing: 0,
  width: '100%',
};
const GAME_LIST_STICKY_TH_STYLE = {
  position: 'sticky',
  top: 0,
  zIndex: 6,
  backgroundColor: '#f8f9fe',
  backgroundClip: 'padding-box',
  boxShadow: '0 1px 0 #dee2e6',
};

const HISTORY_PAGINATION_INFO_STYLE = {
  fontSize: '0.875rem',
  color: '#8898aa',
  lineHeight: 1.4,
};

const getHistoryPaginationFooterStyle = (phone) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: phone ? 'stretch' : 'center',
  justifyContent: 'space-between',
  gap: phone ? '0.75rem' : '0.75rem 1rem',
  padding: phone ? '0.75rem 1rem' : '0.75rem 1.25rem',
  flexDirection: phone ? 'column' : 'row',
  textAlign: phone ? 'center' : 'left',
});

const getHistoryPaginationControlsStyle = (phone) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: phone ? 'center' : 'flex-end',
  gap: phone ? '1.5rem' : '1rem',
});

const getHistoryPaginationLinkStyle = (phone, disabled) => ({
  background: 'none',
  border: 'none',
  padding: phone ? '0.5rem 0.75rem' : '0.25rem 0',
  fontSize: '0.875rem',
  color: disabled ? '#adb5bd' : '#5e72e4',
  cursor: disabled ? 'not-allowed' : 'pointer',
  lineHeight: 1.4,
  textDecoration: 'none',
  minHeight: phone ? 44 : undefined,
  minWidth: phone ? '5rem' : undefined,
});

function GameList(props) {
  const [clubId, setClubId] = useState(session.get('clubInfo').clubId);
  const [games, setGames] = useState([]);
  const [rawGames, setRawGames] = useState([]);
  const [isPhone, setIsPhone] = useState(window.innerWidth <= PHONE_MAX_WIDTH);
  const [members, setMembers] = useState([]);
  const [boxTimeList, setBoxTimeList] = useState([]);
  const [caddies, setCaddies] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const [gpsTrackers, setGpsTrackers] = useState([]);
  const [trackerOptions , setTrackerOptions] = useState([]);
  const [centerLati, setCenterLati] = useState(session.get("clubInfo").latitude);
  const [centerLong, setCenterLong] = useState(session.get("clubInfo").longitude);
  const [has27Holes, setHas27Holes] = useState(session.get('clubInfo').has_27_holes === 'true');
  const [nameOfCourseA, setNameOfCourseA] = useState(session.get('clubInfo').name_of_course_a);
  const [nameOfCourseB, setNameOfCourseB] = useState(session.get('clubInfo').name_of_course_b);
  const [nameOfCourseC, setNameOfCourseC] = useState(session.get('clubInfo').name_of_course_c);
  const {selectedCourse, SelectCourse} = useCourseSelection({nameOfCourseA, nameOfCourseB, nameOfCourseC});

  const newGameTemplate = {
    type: '18',
    status: 'created',
    tracker_type: 'gps',
    start_box: 1,
    tracker_id: {},
    tee_time: '10:00',
    date: getLocalDate(),
    selectedMembers: [],
    selectedCaddies: [],
    club_id: clubId
  };
  const history = useHistory();
  const [selectedGame, setSelectedGame] = useState({...newGameTemplate});
  const [teeTimes, setTeeTimes] = useState([]);
  const [gameResponse, setGameResponse] = useState([]);
  const [club, setClub] = useState(session.get('clubInfo'));
  const [modal, setModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(getLocalDate());
  const [historyPage, setHistoryPage] = useState(1);
  const [historyPagination, setHistoryPagination] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: 'actual_time', direction: "asc" });
  const [editEntryTime, setEditEntryTime] = useState('');
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [time, setTime] = useState('10:00');

  const [editBoxID, setEditBoxID] = useState(-1);
  const dateOptions = [
    { label: 'Yesterday', value: getLocalDate(-1) },
    { label: 'Today', value: getLocalDate() },
    { label: 'Tomorrow', value: getLocalDate(1) },
    { label: 'Next Day', value: getLocalDate(2), hideOnPhone: true },
    { label: 'History', value: `history:${getLocalDate()}`, hideOnPhone: true }
  ];
  const lastDateRef = useRef(new Date().toDateString());
  const detailPdfExportRef = useRef(null);
  const [detailPdfGenerating, setDetailPdfGenerating] = useState(false);
  const [facilityClubs, setFacilityClubs] = useState([]);
  const [facilityBoxTimesByClubId, setFacilityBoxTimesByClubId] = useState({});
  /** When editing a sister-course game, members/caddies/tee slots load for that club; restore on close. */
  const [editFormClubId, setEditFormClubId] = useState(null);
  
  useEffect(() => {
    const interval = setInterval(() => {
      const currentDate = new Date().toDateString();
      if (currentDate !== lastDateRef.current) {
        window.location.reload();
      }
    }, 60 * 1000); 

    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
    if(clubId == 1){
      const { state } = props.location;
      if(state === undefined) {
        history.push('/admin/index');
        return;
      }
			const club = state.club;
			setClubId(club.clubId);
      setClub(club);
      setCenterLati(club.latitude);
      setCenterLong(club.longitude);
      setHas27Holes(club.has_27_holes === 'true');
      setNameOfCourseA(club.name_of_course_a);
      setNameOfCourseB(club.name_of_course_b);
      setNameOfCourseC(club.name_of_course_c);
			global.isAdmin = true;
		}
  }, [clubId]);
  
  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth <= PHONE_MAX_WIDTH);
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    const options = gpsTrackers.filter(filterTrackers);
    setTrackerOptions(options.map((tracker) => getTrackerOption(tracker, selectedGame.tracker_type)));
  }, [games, gpsTrackers, selectedGame, editMode]);
  
  useEffect(() => {
    loadGames();
  }, [gameResponse, boxTimeList, selectedDate, historyPagination, facilityBoxTimesByClubId, facilityClubs, club, has27Holes]);
  
  useEffect(() => {
    const fid = resolveFacilityId(club);
    if (!fid || has27Holes) {
      setFacilityClubs([]);
      setFacilityBoxTimesByClubId({});
      return;
    }
    customerApi.getFacilityClubs({
      facility_id: fid,
      requesting_club_id: clubId,
    }).then((response) => {
      if (response.status === 200) {
        setFacilityClubs(response.data || []);
      } else {
        setFacilityClubs([]);
        helper.showToast('Error', response.message || 'Failed to load facility courses.', 3);
      }
    });
  }, [clubId, club, has27Holes]);

  const loadGames = async () => {
    const facilityId = resolveFacilityId(club);
    const facilityCombined = isFacilityCombinedView(facilityId, has27Holes, selectedDate);
    let games;

    if (facilityCombined && facilityClubs.length) {
      const eligibleClubs = facilityClubs.filter((c) => c.has_27_holes !== 'true');
      games = eligibleClubs.flatMap((fc) => {
        const clubGames = (gameResponse || []).filter(
          (g) => Number(g.club_id) === Number(fc.id)
        );
        const boxTimes = facilityBoxTimesByClubId[fc.id] || [];
        const clubTurn = fc.turn === 'true' || fc.turn === true;
        const processed = calculateGameProperties(boxTimes, clubGames, selectedDate, { clubTurn });
        return processed.map((g) => ({
          ...g,
          club_name: fc.name,
          map_marker_label: fc.map_marker_label,
        }));
      });
      games.forEach((game, index) => {
        game['#'] = index + 1;
      });
    } else {
      games = calculateGameProperties(boxTimeList, gameResponse, selectedDate);
      if (isHistoryDate(selectedDate) && historyPagination) {
        const offset = (historyPagination.current_page - 1) * historyPagination.per_page;
        games.forEach((game, index) => {
          game['#'] = offset + index + 1;
        });
      }
    }
    setRawGames(games);
  };

  const handleSelectDate = (value) => {
    setSelectedDate(value);
    setHistoryPage(1);
    if (isHistoryDate(value)) {
      setSortConfig({ key: 'actual_time', direction: 'desc' });
    } else if (isHistoryDate(selectedDate)) {
      setSortConfig({ key: 'actual_time', direction: 'asc' });
    }
    if (!isHistoryDate(value)) {
      setHistoryPagination(null);
    }
  };

  useEffect(() => {
    setHistoryPage(1);
  }, [clubId, selectedCourse]);

  useEffect(() => {
    fetchGames();

    interval && clearInterval(interval);
    if (!isHistoryDate(selectedDate)) {
      interval = setInterval(() => {
        fetchGames();
      }, 10000);
    }

    return () => {
      interval && clearInterval(interval);
    };
  }, [selectedDate, clubId, selectedCourse, historyPage, facilityClubs, club, has27Holes]);

  
  useEffect(() => {
    interval2 && clearInterval(interval2);
    interval2 = setInterval(fetchGpsTrackers, 60000);
    return () => { interval2 && clearInterval(interval2);}
  }, [clubId, club, has27Holes]);
  
  useEffect(() => {
    fetchBoxTimeList();
  }, [clubId, selectedCourse]);

  useEffect(() => {
    fetchMembers();
    fetchCaddies();
    fetchGpsTrackers();
    generateTeeTimeOptions();
  }, [clubId]);
  
  useEffect(() => {
    const gamesWithTrackerNumber = rawGames.map(game => ({
      ...game,
      tracker_number: getTrackerDisplayName(game) || game.tracker_type || ''
    }));
    setGames(sortGames(gamesWithTrackerNumber, sortConfig));
  }, [rawGames, sortConfig, gpsTrackers]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "↕";
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

  const handleHistoryPageChange = (page) => {
    if (!historyPagination) return;
    if (page < 1 || page > historyPagination.last_page) return;
    setHistoryPage(page);
  };

  const fetchBoxTimeList = async () => {
    const payload = { club_id: clubId };
    if(has27Holes) {
      payload['course_id'] = selectedCourse;
    }
    const response = await customerApi.getBoxTimeList(payload);
    if (response.status === 200) {
      setBoxTimeList(response.data);
    }
  }

  const fetchGames = async () => {
    const facilityId = resolveFacilityId(club);
    const facilityCombined = isFacilityCombinedView(facilityId, has27Holes, selectedDate);

    if (facilityCombined) {
      if (!facilityClubs.length) {
        return;
      }
      const eligibleClubs = facilityClubs.filter((c) => c.has_27_holes !== 'true');
      const results = await Promise.all(
        eligibleClubs.map(async (fc) => {
          const gamesPayload = { club_id: fc.id, date: selectedDate };
          const [gamesRes, boxRes] = await Promise.all([
            customerApi.getGames(gamesPayload),
            customerApi.getBoxTimeList({ club_id: fc.id }),
          ]);
          return {
            club: fc,
            games: gamesRes.status === 200 ? gamesRes.data : [],
            boxTimes: boxRes.status === 200 ? boxRes.data : [],
          };
        })
      );
      const boxMap = {};
      const merged = [];
      results.forEach(({ club: fc, games: clubGames, boxTimes }) => {
        boxMap[fc.id] = boxTimes;
        clubGames.forEach((g) => merged.push(g));
      });
      setFacilityBoxTimesByClubId(boxMap);
      setGameResponse(merged);
      setHistoryPagination(null);
      return;
    }

    const payload = { club_id: clubId, date: selectedDate };
    if (has27Holes) {
      payload.course_id = selectedCourse;
    }
    if (isHistoryDate(selectedDate)) {
      payload.page = historyPage;
      payload.per_page = HISTORY_PER_PAGE;
    }
    const response = await customerApi.getGames(payload);
    if (response.status === 200) {
      setGameResponse(response.data);
      setHistoryPagination(response.meta || null);
    }
  };

  const fetchMembers = async () => {
    const response = await customerApi.getMembers({ club_id: clubId });
    if (response.status === 200) {
      setMembers(response.data);
    }
  };

  const fetchCaddies = async () => {
    const response = await customerApi.getCaddies({ club_id: clubId });
    if (response.status === 200) {
      setCaddies(response.data);
    }
  };


  const fetchGpsTrackers = async () => {
    const facilityId = resolveFacilityId(club);
    const request =
      facilityId && !has27Holes
        ? customerApi.getFacilityTrackers({ facility_id: facilityId })
        : customerApi.getGpsTrackers({ club_id: clubId });
    const response = await request;
    if (response.status === 200) {
      setGpsTrackers(response.data.sort((a, b) => a.name.localeCompare(b.name)));
    }
  };

  function getNextClosestTime() {
    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes(); // Convert current time to minutes
    const gameTeeTimes = games.map(game => game.tee_time);
    const timeList = teeTimes.map(t => t.value).filter(v => !gameTeeTimes.includes(v)); 
    // Convert list times to minutes and sort them
    const sortedTimes = timeList
        .map(time => {
            const [hours, minutes] = time.split(':').map(Number);
            return { time, totalMinutes: hours * 60 + minutes };
        })
        .sort((a, b) => a.totalMinutes - b.totalMinutes);

    // Find the next closest time
    for (let entry of sortedTimes) {
        if (entry.totalMinutes > currentTime) {
            return entry.time; // Return the first time greater than the current time
        }
    }

    // If no future time exists, return the first time of the next day (loop around)
    return sortedTimes.length > 0 ? sortedTimes[0].time : null;
  }

  const createOrUpdateGame = async () => {
    if(selectedGame.tee_time === 'custom') {
      selectedGame.tee_time = selectedGame.customTeeTime;
    }
    selectedGame.selectedMembers = selectedGame.selectedMembers?.map(m => m.value);
    selectedGame.selectedCaddies = selectedGame.selectedCaddies?.map(c => c.value);
    selectedGame.tracker_id = selectedGame.tracker_id?.value || '';
    if(has27Holes) {
      selectedGame.course_id = selectedCourse;
    }
    const response = editMode ? await customerApi.updateGame(selectedGame) : await customerApi.createGame(selectedGame);
    if (response.status === 200) {
      helper.showToast('Success', `Game ${editMode ? 'updated' : 'created'} successfully.`, 1);
      fetchGames();
      closeGameModal();
    } else {
      helper.showToast('Error', `Failed to ${editMode ? 'update' : 'create'} game.`, 3);
    }
  };

  function timeToMinutes(timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  }

  const checkBoxEntry = async () => {
    const response = await adminService.checkBoxEntry({latitude: Number(latitude), longitude: Number(longitude), game_id: selectedGame.id, time: time});
    if (response.status === 200) {
      helper.showToast('Success', `Tracker Data Processed.`, 1);
      fetchGames();
      setEditBoxID(-1);
    } else {
      helper.showToast('Error', `Failed to Process Tracker Data.`, 3);
    }
  }


  const saveBoxEntryTime = async (boxEntry = {}) => {
    let entryTime = null;

    const element = document.getElementById(
      !boxEntry.box_number ?
        `game-${selectedGame.id}-nextHoleEntryTime` 
      : 
        `${selectedGame.id}-${boxEntry.box_number}-boxEntryInput`
    );
    
    entryTime = `${selectedGame.date} ${element.value}`;
    if(!element.value || element.value === '00:00') {
      helper.showToast('Error', `Can't generate new entry please choose entry time`, 3);
      return;
    }
    const response = await adminService.saveBoxEntryTime({box_number: boxEntry.box_number, entry_time: entryTime, game_id: selectedGame.id});
    if (response.status === 200) {
      helper.showToast('Success', `Game updated successfully.`, 1);
      fetchGames();
      setEditBoxID(-1);
    } else {
      helper.showToast('Error', `Failed to update game.`, 3);
    }
  }

  const buildTeeTimeOptions = (clubSettings) => {
    const options = [{ value: 'custom', label: 'Add Custom' }];
    const { tee_start, tee_end, tee_duration } = clubSettings || {};
    if (tee_start && tee_end && tee_duration) {
      const start = timeToMinutes(tee_start);
      const end = timeToMinutes(tee_end);
      const duration = tee_duration;
      let currentTime = start;

      while (currentTime <= end) {
        const hours = Math.floor(currentTime / 60);
        const minutes = currentTime % 60;
        const formatted24Hour = format24Hours(hours, minutes);
        const formatted12Hour = format12Hours(hours, minutes);
        options.push({ value: formatted24Hour, label: formatted12Hour });
        currentTime += duration;
      }
    }
    return options;
  };

  const generateTeeTimeOptions = () => {
    setTeeTimes(buildTeeTimeOptions(club));
  };

  const restoreEditFormForSessionClub = () => {
    fetchMembers();
    fetchCaddies();
    generateTeeTimeOptions();
  };

  const closeGameModal = () => {
    const loadedForOtherClub =
      editFormClubId != null && Number(editFormClubId) !== Number(clubId);
    setModal(false);
    setEditMode(false);
    if (loadedForOtherClub) {
      restoreEditFormForSessionClub();
    }
    setEditFormClubId(null);
  };
  const deleteGame = async (game) => {
    const courseHint =
      Number(game.club_id) !== Number(clubId) && game.club_name
        ? ` on ${game.club_name}`
        : '';
    if (!window.confirm(`Are you sure you want to delete this game${courseHint}?`)) return;

    const response = await customerApi.deleteGame({ id: game.id });
  
    if (response.status === 200) {
      helper.showToast('Success', 'Game deleted successfully.', 1);
      fetchGames(); // Refresh the game list
    } else {
      helper.showToast('Error', 'Failed to delete game.', 3);
    }
  }; 

  const setCurrentGameForEdit = (game, teeTimesList = teeTimes) => {
    const option = teeTimesList.find((option) => option.value === game.tee_time);
    const tracker = (gpsTrackers.find(device => device.tracking_id === game.tracker_id));
    setSelectedGame({
      ...game,
      selectedMembers: game.members.map(member => ({
        value: member.id,
        label: `${member.first_name} ${member.last_name} (${member.email} - ${member.phone})`
      })),
      selectedCaddies: game.caddies.map(caddie => ({
        value: caddie.id,
        label: `${caddie.first_name} ${caddie.last_name} (${caddie.email} - ${caddie.phone})`
      })),
      tracker_id: tracker ? getTrackerOption(tracker, game.tracker_type) : {value: game.tracker_id, label: "AccuCaddie"},
      tee_time: !option ? 'custom': game.tee_time ,
      customTeeTime: game.tee_time,
    });
  }
  const openEditModal = async (game) => {
    const targetClubId = Number(game.club_id) || Number(clubId);
    let optionsForGame = teeTimes;

    if (targetClubId !== Number(clubId)) {
      const fc = facilityClubs.find((c) => Number(c.id) === targetClubId);
      optionsForGame = buildTeeTimeOptions(fc || club);
      const [membersRes, caddiesRes] = await Promise.all([
        customerApi.getMembers({ club_id: targetClubId }),
        customerApi.getCaddies({ club_id: targetClubId }),
      ]);
      if (membersRes.status === 200) {
        setMembers(membersRes.data);
      } else {
        setMembers([]);
      }
      if (caddiesRes.status === 200) {
        setCaddies(caddiesRes.data);
      } else {
        setCaddies([]);
      }
      setTeeTimes(optionsForGame);
      setEditFormClubId(targetClubId);
    } else {
      optionsForGame = buildTeeTimeOptions(club);
      setTeeTimes(optionsForGame);
      setEditFormClubId(Number(clubId));
    }

    setCurrentGameForEdit(game, optionsForGame);
    setEditMode(true);
    setModal(true);
  };

  const isGameInFacilityScope = (game) =>
    facilityClubs.some((fc) => Number(fc.id) === Number(game.club_id));

  /** Facility combined view: edit/delete any game listed for this facility (sister courses). */
  const canManageFacilityGame = (game) => {
    const facilityId = resolveFacilityId(club);
    if (!isFacilityCombinedView(facilityId, has27Holes, selectedDate)) {
      return true;
    }
    return isGameInFacilityScope(game);
  };

  const canEditGame = canManageFacilityGame;
  const canDeleteGame = canManageFacilityGame;

  const openDetailModal = (game) => {
    setDetailModal(true);
    setSelectedGame(game);
  };

  const handleDownloadDetailPdf = async () => {
    const el = detailPdfExportRef.current;
    if (!el || !selectedGame?.id || isPhone) return;
    setDetailPdfGenerating(true);
    setEditBoxID(-1);
    await new Promise((resolve) => requestAnimationFrame(() => resolve()));
    try {
      const safeDate = selectedGame.date ? String(selectedGame.date).replace(/[^\w.-]/g, '') : 'export';
      const filename = `game-detail-${selectedGame.id}-${safeDate}.pdf`;
      await html2pdf()
        .set({
          margin: 10,
          filename,
          image: { type: 'jpeg', quality: 0.93 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            logging: false,
            windowWidth: el.scrollWidth,
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        })
        .from(el)
        .save();
    } catch (err) {
      console.error('PDF export failed', err);
    } finally {
      setDetailPdfGenerating(false);
    }
  };

  useEffect(() => {
    console.log("game changed ", selectedGame);
  }, [selectedGame])
  const openCreateModal = () => {
    if (editFormClubId != null && Number(editFormClubId) !== Number(clubId)) {
      restoreEditFormForSessionClub();
    }
    setEditFormClubId(null);
    setModal(true);
    setEditMode(false);
    const nextTee = getNextClosestTime() || '10:00';
    const newDate = selectedDate.includes("history") || selectedDate == getLocalDate(-1) ? getLocalDate() : selectedDate;
    setSelectedGame({...newGameTemplate, tee_time: nextTee, date: newDate  });
  }

  const getTrackerLabel = (tracker, type) => {
    if (type === 'airtag') {
      return `airtag: ${tracker.name}`;
    }
    const battery = formatBatteryLevel(tracker.battery_level);
    return battery === '—'
      ? `gps: ${tracker.name}`
      : `gps: ${tracker.name} - ${battery}`;
  };

  /** Assigned tracker name: part before first hyphen (e.g. "1 - Unit A" → "1"). Uses game.tracker_name from API when present, else from gpsTrackers. */
  const getTrackerDisplayName = (game) => {
    if (game.tracker_type === 'app') return 'App';
    let name = game.tracker_name ?? gpsTrackers.find(device => device.tracking_id === game.tracker_id)?.name ?? '';
    if (!name) return '';
    const beforeHyphen = (name.split('-')[0] || '').trim();
    return beforeHyphen || name;
  };

  const getTrackerOption = (tracker, type) => {
    const result = {value: tracker.tracking_id, label: getTrackerLabel(tracker, type)};
    if(type === "gps") {
      result.color = getBatteryLevelStyle(tracker?.battery_level);
    } else {
      result.color = {backgroundColor: 'grey'};
    }
    return result;
  }

  const filterTrackers = (tracker) => {
    const game = games.find((g) => g.tracker_id  === tracker.tracking_id)
    if(game && game.status !== "completed" && game.id !== selectedGame.id) {
      
      if(diffInMinutes(game.tee_time, selectedGame.tee_time) >= 3 * 60) {
        return true;
      }
      return false;
    }
    return true;
  };

  useEffect(() => {
    if(selectedGame.id) {
      const game = games.find((game) => game.id === selectedGame.id);
      if(game) {
        if(!editMode && !modal) {
          setSelectedGame(game);
        }
      }
    }
  }, [games, editMode, modal]);

  const facilityId = resolveFacilityId(club);
  const facilityCombined = isFacilityCombinedView(facilityId, has27Holes, selectedDate);
  const mapCenter = (() => {
    if (facilityCombined && facilityClubs.length) {
      const withCoords = facilityClubs.filter(
        (c) => c.latitude != null && c.longitude != null && c.latitude !== '' && c.longitude !== ''
      );
      if (withCoords.length) {
        const lat =
          withCoords.reduce((s, c) => s + parseFloat(c.latitude), 0) / withCoords.length;
        const lng =
          withCoords.reduce((s, c) => s + parseFloat(c.longitude), 0) / withCoords.length;
        return { lat, lng, zoom: 14 };
      }
    }
    return {
      lat: parseFloat(centerLati) || 0,
      lng: parseFloat(centerLong) || 0,
      zoom: 16,
    };
  })();

  return (
    <>
      <AddClubHeader 
        tableData={{
          rows: gpsTrackers
            .filter((tracker) => isLowBattery(tracker.battery_level))
            .map((tracker) => ({
              name: tracker.name,
              battery_level: formatBatteryLevel(tracker.battery_level),
            })),
          cols: {name: "Name", battery_level: "Battery Level"}
        }}
        isMobile={isPhone}
      />
      <Container className={isPhone ? "mt-2" : "mt-4"} fluid>
        <Modal isOpen={showMap} toggle={() => setShowMap(false)} modalClassName="map-modal">
            <div style={{ height: '95vh', width: '100%', position: 'relative'  }}>
              <GoogleMapReact
                  bootstrapURLKeys={{ key: 'AIzaSyCk2rpWi4waVXWK-zBmstyi7JJOlHinwI8' }}
                  yesIWantToUseGoogleMapApiInternals
                  defaultCenter={{
                      lat: mapCenter.lat,
                      lng: mapCenter.lng
                  }}
                  defaultZoom={mapCenter.zoom}
                  options={(maps) => ({
                    mapTypeId: maps.MapTypeId.SATELLITE,
                    rotateControl: true,
                  })}
              >
                {
                  games.filter(game => game.last_lat_long).map((game, index) => 
                    <CustomMarker
                      key={index}
                      lat={game.last_lat_long[0]}
                      lng={game.last_lat_long[1]}
                      game={{
                        ...game,
                        actual_time: game.actual_time_org ? strTo24Hours(game.actual_time_org) : game.tee_time,
                        caddie_name: (
                          gpsTrackers.find(device => device.tracking_id === game.tracker_id)
                        )?.caddie_name || game.tracker_type,
                        tracker_number: getTrackerDisplayName(game) || null
                      }}
                      allGames={games}
                      label={game.map_marker_label || club.map_marker_label || "start_time"}
                    />
                  )
                }
              </GoogleMapReact>
<Button
                color="danger"
                style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}
                onClick={() => setShowMap(false)}
              >
                Close Map
              </Button>
              <MapLegend />
            </div>
          </Modal>
        <Row>
          <Col xl="12">
            <Card className="shadow">
              <CardHeader className="bg-white border-0 d-flex flex-wrap justify-content-between align-items-center">
                <h3 className="mb-0">Games
                {has27Holes && <SelectCourse/>}
                </h3>
                <div className="d-flex flex-wrap">
                  {dateOptions.filter((option) => !option.hideOnPhone || !isPhone).map((option) => (
                    <Button
                      key={option.value}
                      color={selectedDate === option.value ? 'primary' : 'secondary'}
                      onClick={() => handleSelectDate(option.value)}
                      className="mb-2"
                      size="sm"
                    >
                      {option.label}
                    </Button>
                  ))}
                </div>
                <div className="d-flex flex-wrap">
                  <Button color="primary" onClick={() => setShowMap(true)} className="mr-2 mb-2">
                    View Map
                  </Button>
                  <Button color="primary" onClick={openCreateModal} className="mb-2" disabled={selectedDate.includes('history') || selectedDate === getLocalDate(-1)}>
                    Create Game
                  </Button>
                </div>
              </CardHeader>
        
              <CardBody style={{ padding: '0.5rem', minHeight: 0 }}>
                <div
                  style={{
                    width: '100%',
                    minHeight: 0,
                    maxHeight: isPhone
                      ? 'min(72vh, calc(100vh - 140px))'
                      : 'min(78vh, calc(100vh - 200px))',
                    overflowX: 'auto',
                    overflowY: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    overscrollBehavior: 'contain',
                  }}
                >
                  <Table hover size="sm" className="mb-0" style={GAME_LIST_TABLE_STYLE}>
                    <thead className="thead-light">
                      <tr>
                        {!isPhone && 
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort(global.isAdmin ? 'id' : '#')}>{global.isAdmin ? 'ID' : '#'} 
                            <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon(global.isAdmin ? 'id' : '#')}</span>
                          </th>
                        }
                        {facilityCombined && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('club_name')}>
                            Course <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('club_name')}</span>
                          </th>
                        )}
                        {!isPhone && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('type')}>
                            Type <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('type')}</span>
                          </th>
                        )}
                        {/* {!isPhone && <th className="py-2 px-2">Members</th>} */}
                        {/* {!isPhone && <th className="py-2 px-2">Caddies</th>} */}
                        <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => !isPhone && handleSort('tee_time')}>
                          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <div>{isPhone ? 'Tracker #' : <>Tee<br />Time </>}</div>
                            {!isPhone && <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('tee_time')}</span>}
                          </div>
                        </th>
                        <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('actual_time')}>
                          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <div>Start<br />Time</div>
                            <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('actual_time')}</span>
                          </div>
                        </th>
                        <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('start_hole')}>
                          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <div>Start<br />Hole</div>
                            <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('start_hole')}</span>
                          </div>
                        </th>
                        <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('last_hole_played')}>
                          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <div>Last<br />Hole</div>
                            <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('last_hole_played')}</span>
                          </div>
                        </th>
                        {!isPhone && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('total_holes_played')}>
                            <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                              <div>Holes<br />Played</div>
                              <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('total_holes_played')}</span>
                            </div>
                          </th>
                        )}
                        <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('time_through_last_hole_org')}>
                          <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            Last<br />Time
                            <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('time_through_last_hole_org')}</span>
                          </div>
                        </th>
                        <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('pace')} >
                          Pace
                          <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('pace')}</span>
                        </th>
                        {isPhone && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('totalScore')}>
                            <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                              <div>Scoring</div>
                              <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('totalScore')}</span>
                            </div>
                          </th>
                        )}
                        {isPhone && global.isAdmin && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('transport_mode')}>
                            Transport <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('transport_mode')}</span>
                          </th>
                        )}
                        {isPhone && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('status')}>
                            <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                              <div>Status</div>
                              <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('status')}</span>
                            </div>
                          </th>
                        )}
                        {!isPhone && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('tracker_number')}>
                            Tracker # <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('tracker_number')}</span>
                          </th>
                        )}
                        {!isPhone && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('totalScore')}>
                            Scoring <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('totalScore')}</span>
                          </th>
                        )}
                        {!isPhone && global.isAdmin && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('transport_mode')}>
                            Transport <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('transport_mode')}</span>
                          </th>
                        )}
                        {!isPhone && (
                          <th className="py-2 px-2 cursor-pointer" style={GAME_LIST_STICKY_TH_STYLE} onClick={() => handleSort('status')}>
                            Status <span style={{ marginLeft: 5, fontSize: '20px' }}>{getSortIcon('status')}</span>
                          </th>
                        )}
                        {!isPhone && (
                          <th className="py-2 px-2" style={GAME_LIST_STICKY_TH_STYLE}>
                            Actions
                          </th>
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {games.map((game, index) => (
                        <tr key={game.id} style={{ fontSize: '0.85rem' }} onClick={() => openDetailModal(game)}>
                          {!isPhone && <td className="py-1 px-2">{global.isAdmin ? game.id : game['#']}</td>}
                          {facilityCombined && <td className="py-1 px-2">{game.club_name}</td>}
                           {!isPhone && <td className="py-1 px-2">{game.display_type}</td>}

                          {/* {!isPhone && (
                            <td className="py-1 px-2">
                              <span className="ctooltip">
                                {game.members.length}
                                <span className="ctooltip-text">
                                  {game.members.length
                                    ? game.members.map((m) => `${m.first_name} ${m.last_name}`).join(', ')
                                    : "No Member"}
                                </span>
                              </span>
                            </td>
                          )} */}

                          {/* {!isPhone && (
                            <td className="py-1 px-2">
                              <span className="ctooltip">
                                {game.caddies.length}
                                <span className="ctooltip-text">
                                  {game.caddies.length
                                    ? game.caddies.map((caddie) => `${caddie.first_name} ${caddie.last_name}`).join(', ')
                                    : "No Caddie"}
                                </span>
                              </span>
                            </td>
                          )} */}

                          <td className="py-1 px-2">
                            {isPhone
                              ? getTrackerDisplayName(game)
                              : <>{game.tee_time && strTo12Hours(game.tee_time)} {game.auto_game === 1 && '*'}</>
                            }
                          </td>
                          <td className="py-1 px-2">{game.actual_time}</td>
                          <td className="py-1 px-2">{game.start_hole}</td>
                          <td className="py-1 px-2">{game.last_hole_played}</td>
                          {!isPhone && <td className="py-1 px-2">{game.total_holes_played}</td>}
                          <td className="py-1 px-2">{game.time_through_last_hole}</td>
                          <td className="py-1 px-2" style={{ color: game.pace_formatted[0] === '(' ? 'red' : 'green' }}>
                          {game.pace_formatted}
                          </td>
                          {isPhone && <td className="py-1 px-2">{game.totalScore || 0}</td>}
                          {isPhone && global.isAdmin && <td className="py-1 px-2">{getTransportDisplay(game)}</td>}
                          {isPhone && <td className="py-1 px-2">{statusText[game.status]}</td>}
                          {!isPhone && (
                            <td className="py-1 px-2">
                              {getTrackerDisplayName(game) || game.tracker_type}
                            </td>
                          )}
                          {!isPhone && (
                            <td className="py-1 px-2">
                              {game.totalScore || 0}
                            </td>
                          )}
                          {!isPhone && global.isAdmin && (
                            <td className="py-1 px-2">{getTransportDisplay(game)}</td>
                          )}
                          {!isPhone && <td className="py-1 px-2">{statusText[game.status]}</td>}
                          {!isPhone && <td className="py-1 px-2">
                              <Button color="secondary" size="sm" onClick={(e) => {e.stopPropagation(); openDetailModal(game);}} className="mr-1 mb-1 p-1">
                                Detail
                              </Button>
                              {game.status !== 'completed' && canEditGame(game) && (
                                <Button color="info" size="sm" onClick={(e) => { e.stopPropagation(); openEditModal(game);}} className="mr-1 mb-1 p-1">
                                  Edit
                                </Button>
                              )}
                              {canDeleteGame(game) && (
                              <Button 
                                color="danger" 
                                size="sm" 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteGame(game)
                                }} 
                                className="mb-1 p-1"
                              >
                                Delete
                              </Button>
                              )}
                            </td>}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
              {isHistoryDate(selectedDate) && historyPagination && (
                <CardFooter
                  className="bg-white border-top"
                  style={getHistoryPaginationFooterStyle(isPhone)}
                >
                  <span style={HISTORY_PAGINATION_INFO_STYLE}>
                    Page {historyPagination.current_page} of {historyPagination.last_page}
                    {' '}({historyPagination.total} games)
                  </span>
                  {historyPagination.last_page > 1 && (
                    <div style={getHistoryPaginationControlsStyle(isPhone)}>
                      <button
                        type="button"
                        style={getHistoryPaginationLinkStyle(isPhone, historyPagination.current_page <= 1)}
                        disabled={historyPagination.current_page <= 1}
                        onClick={() => handleHistoryPageChange(historyPagination.current_page - 1)}
                      >
                        Previous
                      </button>
                      <button
                        type="button"
                        style={getHistoryPaginationLinkStyle(isPhone, historyPagination.current_page >= historyPagination.last_page)}
                        disabled={historyPagination.current_page >= historyPagination.last_page}
                        onClick={() => handleHistoryPageChange(historyPagination.current_page + 1)}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </CardFooter>
              )}
            </Card>
          </Col>
        </Row>
        <Modal isOpen={detailModal} toggle={() => setDetailModal(!detailModal)}>
          <div className="modal-header py-2 align-items-start border-bottom">
            <h5 className="modal-title mb-0 pr-3">Details</h5>
            <div className="d-flex flex-column align-items-end flex-shrink-0">
              <button
                type="button"
                className="close m-0 p-1"
                onClick={() => setDetailModal(!detailModal)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              {!isPhone && (
                <Button
                  color="primary"
                  outline
                  size="sm"
                  className="mt-2 text-nowrap"
                  disabled={detailPdfGenerating}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadDetailPdf();
                  }}
                >
                  {detailPdfGenerating ? 'Preparing PDF…' : 'Download PDF'}
                </Button>
              )}
            </div>
          </div>
          <ModalBody>
            {isPhone && (
              <div style={{ marginBottom: 16 }}>
                {[
                  { label: "Type", value: selectedGame.type },
                  { label: "Tee Time", value: selectedGame.tee_time ? strTo12Hours(selectedGame.tee_time) : "" },
                  { label: "Start Time", value: selectedGame.actual_time },
                  { label: "Start Hole", value: selectedGame.start_hole },
                  {
                    label: "Tracker",
                    value: `${selectedGame.tracker_type} - ${
                      (gpsTrackers.find(device => device.tracking_id === selectedGame.tracker_id)
                      )?.name || "N/A"
                    }`
                  },
                  ...(global.isAdmin
                    ? [
                        {
                          label: "Transport",
                          value: getTransportDisplay(selectedGame) || '—',
                        },
                      ]
                    : []),
                  {
                    label: "Members",
                    value: selectedGame.members?.length
                          ? selectedGame.members.map((m) => `${m.first_name} ${m.last_name}`).join(', ')
                          : "No Member"
                  },
                  {
                    label: "Caddies",
                    value: selectedGame.caddies?.length
                        ? selectedGame.caddies.map((caddie) => `${caddie.first_name} ${caddie.last_name}`).join(', ')
                        : "No Caddie"
                  },
                  {
                    label: "Status",
                    value: statusText[selectedGame.status]
                  }
                ].map((item, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: 4, 
                      marginTop: 12, 
                      color: "#222", 
                      background: "#f9f9f9",
                      padding: "8px 12px",
                      borderRadius: 8,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}
                  >
                    <span style={{ fontWeight: '600', fontSize: 14, color: '#444' }}>
                      {item.label}
                    </span>
                    <span style={{ fontSize: 13, color: '#666' }}>
                      {item.value}
                    </span>
                  </div>
                ))}

                <div className="mt-2">
                  {selectedGame.status !== 'completed' && canEditGame(selectedGame) && (
                    <Button color="info" size="sm" onClick={() => openEditModal(selectedGame)} className="mr-1 mb-1 p-1">
                      Edit
                    </Button>
                  )}
                </div>
              </div>
            )}
            
            <div>
              <div
                ref={detailPdfExportRef}
                className="game-detail-pdf-export"
                style={{ backgroundColor: '#fff', color: '#212529' }}
              >
              <Table responsive hover size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Hole</th>
                    <th>Actual</th>
                    <th>Standard</th>
                    <th>Variance</th>
                    <th>Cumulative</th>
                    {
                      global.isAdmin && 
                      <th>Entry Time</th>
                    }
                    
                  </tr>
                </thead>
                <tbody>
                  {selectedGame.box_entries_sorted?.filter(b => b.box_number !== 20).map((boxEntry, idx) => (
                    <tr key={idx}>
                      <td>{boxToHoleMappings[boxEntry.box_number]}</td>
                      <td>{boxEntry.timeTaken}</td>
                      <td>{boxEntry.standard}</td>
                      <td style={{ color: boxEntry.variance?.[0] === '(' ? 'red' : 'green' }}>
                        {boxEntry.variance || ''}
                      </td>
                      <td style={{ color: boxEntry.cumulative?.[0] === '(' ? 'red' : 'green' }}>
                        {boxEntry.cumulative || ''}
                      </td>
                      {
                        global.isAdmin &&
                        <td>
                          {
                            editBoxID === boxEntry.id ? 
                              <div className="row">
                                <Input
                                  type="time"
                                  style={{width: "96px"}}
                                  invalid={boxEntry.entry_time !== editEntryTime}
                                  id={`${selectedGame.id}-${boxEntry.box_number}-boxEntryInput`}
                                  value={editEntryTime?.split(" ")?.[1]}
                                  onChange={
                                    (e) => setEditEntryTime(`${boxEntry.entry_time.split(' ')[0]} ${e.target.value}`)
                                          
                                  }
                                />
                                <Button onClick={() => saveBoxEntryTime(boxEntry)}> Save</Button>
                              </div>
                              :
                              <div
                                className='cursor-pointer' 
                                onClick={
                                  () => {
                                    setEditEntryTime(boxEntry.entry_time);
                                    setEditBoxID(boxEntry.id);
                                  }
                                }
                              >
                                {strTo24Hours(boxEntry.entry_time)}
                              </div>
                          }
                        </td>
                      }
                    </tr>
                  ))}
                  <tr>
                    <td></td>
                    <td>{selectedGame.actualTotal}</td>
                    <td>{selectedGame.standardTotal}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </Table>
              {(selectedGame.start_hole === 1 || selectedGame.start_hole === 10) && (
              <div>
                <hr/>

                {/* Per-Snapshot GF/GB Tee Times Table */}
                <div className="">
                <Table bordered className="mb-0" size="sm">
                  <colgroup>
                    <col style={{ width: '26px' }} />
                    <col style={{ width: '30px' }} />
                    <col style={{ width: '80px' }} />
                    <col style={{ width: '80px' }} />
                    <col style={{ width: '80px' }} />
                  </colgroup>
                  <tbody>
                    {[1,2,3,4].map((key) => (
                      <tr key={`tee-${key}`}>
                        <td colSpan="2" style={{ textAlign: 'right' }}>#{key}</td>
                        <td>{selectedGame[`score${key}GFTeeTime`] ? strTo12Hours(selectedGame[`score${key}GFTeeTime`]) : ''}</td>
                        <td>{selectedGame.tee_time ? strTo12Hours(selectedGame.tee_time) : ''}</td>
                        <td>{selectedGame[`score${key}GBTeeTime`] ? strTo12Hours(selectedGame[`score${key}GBTeeTime`]) : ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                </div>

                {/* Main Score Details Table */}
                <Table bordered responsive hover size="sm" className="mb-0" style={{ backgroundColor: '#ffffff' }}>
                  <thead>
                    <tr>
                      <th colSpan="2" ></th>
                      <th colSpan="2" style={{ backgroundColor: '#f8f9fa', textAlign: 'center' }}>Group In<br />Front</th>
                      <th colSpan="2" style={{ backgroundColor: '#f8f9fa', textAlign: 'center' }}>This<br />Group</th>
                      <th colSpan="2" style={{ backgroundColor: '#f8f9fa', textAlign: 'center' }}>Group<br />Behind</th>
                    </tr>
                    <tr>
                      <th style={{ backgroundColor: '#f8f9fa' }}>#</th>
                      <th style={{ backgroundColor: '#f8f9fa' }}>Time</th>
                      <th style={{ backgroundColor: '#f8f9fa' }}>Last<br />Hole</th>
                      <th style={{ backgroundColor: '#f8f9fa' }}>Pace</th>
                      <th style={{ backgroundColor: '#f8f9fa' }}>Last<br />Hole</th>
                      <th style={{ backgroundColor: '#f8f9fa' }}>Pace</th>
                      <th style={{ backgroundColor: '#f8f9fa' }}>Last<br />Hole</th>
                      <th style={{ backgroundColor: '#f8f9fa' }}>Pace</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[1,2,3,4].map((key) => (
                      <tr key={key}>
                        <td>{key}</td>
                        <td>{selectedGame[`score${key}Time`] || ''}</td>
                        <td>{selectedGame[`score${key}GF`] || ''}</td>
                        <td>{selectedGame[`score${key}GFP`] !== undefined && selectedGame[`score${key}GFP`] !== null && selectedGame[`score${key}GFP`] !== '' ? selectedGame[`score${key}GFP`] : ''}</td>
                        <td>{selectedGame[`score${key}LastHole`] || ''}</td>
                        <td>{selectedGame[`score${key}Pace`] !== undefined && selectedGame[`score${key}Pace`] !== null && selectedGame[`score${key}Pace`] !== '' ? selectedGame[`score${key}Pace`] : ''}</td>
                        <td>{selectedGame[`score${key}GB`] || ''}</td>
                        <td>{selectedGame[`score${key}GBP`] !== undefined && selectedGame[`score${key}GBP`] !== null && selectedGame[`score${key}GBP`] !== '' ? selectedGame[`score${key}GBP`] : ''}</td>
                      </tr>
                    ))}
                    <tr key="total-row" style={{ backgroundColor: '#f8f9fa' }}>
                      <td colSpan="8"></td>
                    </tr>
                  </tbody>
                </Table>

                <div className="mt-3">
                  <Table bordered responsive hover size="sm" className="mb-0" style={{ backgroundColor: '#ffffff' }}>
                    <thead>
                      <tr>
                        <th colSpan="3" style={{ backgroundColor: '#f8f9fa' }}></th>
                        <th colSpan="3" style={{ backgroundColor: '#f8f9fa', textAlign: 'center' }}>Scoring Explanation</th>
                      </tr>
                      <tr>
                        <th style={{ backgroundColor: '#f8f9fa' }}>#</th>
                        <th style={{ backgroundColor: '#f8f9fa' }}>Time</th>
                        <th style={{ backgroundColor: '#f8f9fa' }}>Score</th>
                        <th style={{ backgroundColor: '#f8f9fa' }}>Behind<br />Pace</th>
                        <th style={{ backgroundColor: '#f8f9fa' }}>GF is<br />Cause</th>
                        <th style={{ backgroundColor: '#f8f9fa' }}>GB is<br />Impact'd</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[1,2,3,4].map((key) => {
                        const scoreValue = selectedGame[`score${key}`] ?? '';
                        const behindPaceMinutes = selectedGame[`score${key}BehindPace`] ?? 0;
                        
                        // 0 = less than 5 minutes behind
                        // 1 = 5 or more minutes behind
                        const behindPaceCategory = behindPaceMinutes >= 5 ? 1 : 0;
                        
                        let gfIsCause = '';
                        let gbIsImpacted = '';
                        
                        if (behindPaceCategory > 0) {
                          const hasGF = selectedGame[`score${key}GF`] && selectedGame[`score${key}GF`] !== '';
                          const isPrevGameBehind = selectedGame[`score${key}IsPrevGameBehind`] ?? false;
                          const hasGB = selectedGame[`score${key}GB`] && selectedGame[`score${key}GB`] !== '';
                          
                          // GF is Cause: 1 if score is 0 (YES, GF IS the cause), 0 if score > 0 (NO, GF is NOT the cause)
                          if (hasGF) {
                            gfIsCause = scoreValue > 0 ? 0 : 1; 
                          }
                          
                          // GB is Impact'd: 1 if score > 0 (YES, GB IS impacted), 0 if score is 0 (NO, GB is NOT impacted)
                          if (hasGB) {
                            gbIsImpacted = scoreValue > 0 ? 1 : '';
                          }
                        }
                        
                        return (
                          <tr key={`scoring-${key}`}>
                            <td>{key}</td>
                            <td>{selectedGame[`score${key}Time`] ?? ''}</td>
                            <td>{scoreValue}</td>
                            <td>{behindPaceCategory}</td>
                            <td>{gfIsCause}</td>
                            <td>{gbIsImpacted}</td>
                          </tr>
                        );
                      })}
                      <tr style={{ backgroundColor: '#f8f9fa' }}>
                        <td colSpan="2"></td>
                        <td><strong>{selectedGame.totalScore}</strong></td>
                        <td colSpan="2"></td>
                        <td><strong>Total</strong></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>    
              </div>
              )}
              </div>
              {
                global.isAdmin && selectedGame.status !== 'completed' &&
                selectedGame.box_entries_sorted?.[selectedGame.box_entries_sorted?.length - 1]?.box_number !== 20 
                &&
                <div>
                  <hr/>
                  <div className="row justify-content-between">
                    <Input
                      type="time"
                      id={`game-${selectedGame.id}-nextHoleEntryTime`}
                      style={{width: "100px"}}
                    />
                    <Button onClick={() => { saveBoxEntryTime()}}> Save Next Box Entry Time</Button>
                  </div>
                  <hr/>
                  <div className="row">
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="input-city"
                      >
                        Latitude
                      </label>
                      <Input
                        className="form-control-alternative"
                      
                        defaultValue={latitude}
                        placeholder="39.234322"
                        type="number"
                        onChange={(e) => setLatitude(e.target.value)}
                      />
                    </FormGroup>
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="input-country"
                      >
                        Longitude
                      </label>
                      <Input
                        className="form-control-alternative"
                          defaultValue={longitude}
                        placeholder="-82.235325"
                        type="number"
                        onChange={(e) => setLongitude(e.target.value)}
                      />
                    </FormGroup>
                    <FormGroup>
                      <label
                        className="form-control-label"
                        htmlFor="input-country"
                      >
                        Time
                      </label>
                      <Input
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                      />
                    </FormGroup>
                    <Button onClick={() => { checkBoxEntry()}}> Process Tracker Data</Button>

                  </div>
                </div>
              }
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal} toggle={closeGameModal}>
          <ModalHeader toggle={closeGameModal}>{editMode ? 'Edit Game' : 'Create Game'}</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <label>Game Type</label>
                <Input
                  type="select"
                  value={selectedGame.type}
                  onChange={(e) => setSelectedGame({ ...selectedGame, type: e.target.value })}
                >
                  <option value={'9'}>9 Holes</option>
                  <option value={'18'}>18 Holes</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <label>Start Hole</label>
                <Input
                  type="select"
                  value={selectedGame.start_box}
                  onChange={(e) => setSelectedGame({ ...selectedGame, start_box: e.target.value })}
                >
                  {(selectedGame.type === '9' ? [1,10] : Object.keys(holeToBoxMappings)).map((hole, index) => <option value={holeToBoxMappings[hole]} key={index}>{hole}</option>)}
                </Input>
              </FormGroup>
              <FormGroup>
                <label>Game Dated</label>
                <input className='form-control' type="select" value={selectedGame.date} disabled/>
              </FormGroup>
              <FormGroup>
                <label>Select Tee Time</label>
                <Input
                  type="select"
                  value={selectedGame.tee_time}
                  onChange={(e) => setSelectedGame({ ...selectedGame, tee_time: e.target.value })}
                >
                  <option value="">Please select</option>
                  {teeTimes.map((option, index) => <option value={option.value} key={index}>{option.label}</option>)}
                </Input>
              </FormGroup>
              {selectedGame.tee_time === "custom" && (
                <FormGroup>
                  <Label>Custom Tee Time</Label>
                  <Input
                    type="time"
                    value={selectedGame.customTeeTime}
                    required={true}
                    onChange={(e) => setSelectedGame({ ...selectedGame, customTeeTime: e.target.value })}
                  />
                </FormGroup>
              )}
              <FormGroup>
                <label>Tracker</label>
                <Select
                  value={selectedGame.tracker_id}
                  options={selectedGame.tracker_type === 'app' ? [] : trackerOptions}
                    styles={{
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.data.color.backgroundColor,
                        color: 'white'
                      })
                    }}
                    onChange={(selected) => setSelectedGame({ ...selectedGame, tracker_id: selected })}
                />
              </FormGroup>
              {
                <FormGroup>
                <label>Select Golfers</label>
                <Select
                  isMulti
                  value={selectedGame.selectedMembers}
                  options={members.map(member => ({
                    value: member.id,
                    label: `${member.first_name} ${member.last_name} (${member.email || ''} - ${member.phone || ''})`
                  }))}
                  onChange={(selected) => setSelectedGame({ ...selectedGame, selectedMembers: selected })}
                />
                </FormGroup>
              }
              {
                <FormGroup>
                  <label>Select Caddies</label>
                  <Select
                    isMulti
                    value={selectedGame.selectedCaddies}
                    options={caddies.map(caddie => ({
                      value: caddie.id,
                      label: `${caddie.first_name} ${caddie.last_name} (${caddie.email || ''} - ${caddie.phone || ''})`
                    }))}
                    onChange={(selected) => setSelectedGame({ ...selectedGame, selectedCaddies: selected })}
                  />
                </FormGroup>
              }
              {
                editMode && <FormGroup>
                <label>Select Game Status</label>
                <Input
                  type="select"
                  value={selectedGame.status}
                  onChange={(e) => setSelectedGame({ ...selectedGame, status: e.target.value })}
                >
                  {Object.keys(statusText).map(key => <option value={key}>{statusText[key]}</option>)} 
                </Input>
              </FormGroup>
              }
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={createOrUpdateGame}>{editMode ? 'Update Game' : 'Create Game'}</Button>{' '}
            <Button color="secondary" onClick={closeGameModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
}

export default GameList;
